// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__6hTAm","name":"name__skYIe","badge":"badge__qKIqc","indent":"indent__h5Otu","confidence":"confidence__9OArU"};